import { Base } from "../../../../base/components/base"
import { ISocialMedia } from "../social-media-prices/smp-item"
import { CheckTd } from "./check-td"
import { LinkTd } from "./link-td"
import { NameTd } from "./name-td"
import { PriceTd } from "./price-td"
import { rateTrStyle } from "./rate-tr.style"

export const RateTr = (rate?: ISocialMedia) => {

    let changed = false

    const base = Base('tr')
    base.cssClass(rateTrStyle)

    if (!rate) return base
    const { key, title, value, details } = rate

    const name = NameTd(title)
    base.append(name)

    const price = PriceTd(value)
    base.append(price)

    const link = LinkTd(details)
    base.append(link)

    const db = CheckTd(false)
    db.disable()
    base.append(db)

    // const telegram = CheckTd(false)
    // telegram.disable()
    // base.append(telegram)

    price.on('change', handleChange)
    link.on('change', handleChange)

    function handleChange() {
        changed = price.changed() || link.changed()
        if (changed) {
            db.enable()
            db.check()
            // telegram.enable()
        } else {
            db.disable()
            // telegram.disable()
        }
    }

    return Object.assign(base, {
        getValue: () => {
            return {
                meta: {
                    db: db.getValue(),
                    // telegram: telegram.getValue()
                },
                value: {
                    key,
                    title,
                    value: price.getValue().value,
                    change: price.getValue().change,
                    details: link.getValue()
                },
                changed
            }
        },
        update: (newValue: string, newDetails: string) => {
            price.update(newValue)
            // link.update(newDetails)
            changed = false
            db.disable()
            // telegram.disable()
        }
    })
}